











































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { DataCenters } from '@/modules/shared/shared/domain/constants/constants';
import VueApexCharts from 'vue-apexcharts/dist/vue-apexcharts';

@Component({
    components: {
        apexchart: VueApexCharts,
    },
    name: 'quarter-interruptions-summary',
})
export default class QuarterInterruptionSummary extends Vue {
    @Prop({ required: true })
    quarterIncidentsReport!: { id: number; total: number }[];

    dataCenterSelected: number = DataCenters.DATA_CENTER_CARACAS.id;
    incidentItem: { id: number; total: number } | undefined;
    dataCenterValenciaSelected: boolean = false;
    DATA_CENTER_CCS_ID: number = DataCenters.DATA_CENTER_CARACAS.id;
    DATA_CENTER_CCS_NAME: string = DataCenters.DATA_CENTER_CARACAS.alias;
    DATA_CENTER_VAL_ID: number = DataCenters.DATA_CENTER_VALENCIA.id;
    DATA_CENTER_VAL_NAME: string = DataCenters.DATA_CENTER_VALENCIA.alias;

    get chartOptions() {
        return {
            chart: {
                type: 'bar',
                size: 300,
                stacked: true,
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '35%',
                },
            },
            dataLabels: {
                enabled: false,
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                crosshairs: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                    style: {
                        fontSize: '11px',
                    },
                },
            },
            fill: {
                // type: 'gradient',
                // gradient: {
                //     shadeIntensity: 1,
                //     opacityFrom: 0.7,
                //     opacityTo: 0.9,
                //     stops: [0, 90, 100]
                // }
            },
            colors: ['#94CA4E', '#00AAB8'],
            stroke: {
                show: true,
                width: 1,
                colors: ['transparent'],
            },
            legend: {
                show: false,
            },
        };
    }

    get series() {
        return [
            {
                name: 'Empty',
                data: [44],
            },
            {
                name: 'Success',
                data: [5, 0],
            },
        ];
    }

    changeDataCenter(dataCenterId: number) {
        this.dataCenterSelected = dataCenterId;
        this.dataCenterValenciaSelected = !this.dataCenterValenciaSelected;
    }

    @Watch('dataCenterValenciaSelected')
    changeValues() {
        this.getCurrentItem();
    }

    getCurrentItem() {
        this.incidentItem = this.quarterIncidentsReport.find(
            element => element.id === this.dataCenterSelected,
        );
    }

    created() {
        this.getCurrentItem();
    }
}
